import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppRoutingService } from './app-routing.service';
import { tap } from 'rxjs/operators';
import { state2 } from './state';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';

export const enum DocumentAction {
  View = 0,
  Download = 1,
  ViewNewTab = 2
}

export interface IDocumentMode {
  cssclass:string;
  title:string;
  selected?:boolean;
  id:DocumentAction
}

@Injectable({ providedIn: 'root' })
export class AppService {

  private _refreshSubject: Subject<boolean>;
  public refresh$: Observable<boolean>;
  public currentDocumentMode: IDocumentMode;
  // public documentAction: DocumentAction;
  // public documentActionIndex:number = 0;
  public document
  private channel: BroadcastChannel;

  private baseUrl: string;
  constructor(public routing: AppRoutingService, @Inject(APP_BASE_HREF) private baseHref: string) {
    // this.channel = new BroadcastChannel('cobradebug');
    // routing.setDebugChannel(this.channel);
    this._refreshSubject = new Subject<boolean>();
    this.refresh$ = this._refreshSubject.asObservable().pipe(
      tap(_ => state2.clear()),
    );
    this.theme = 'green';
    //this.baseUrl = window['baseUrl']+'/';
    this.baseUrl = this.baseHref;
  }

  // private zittingId: number;  // TEST REFRESH
  // setZittingId = (zittingId: number) => { this.zittingId = zittingId; } // TEST REFRESH
  // getZittingId = () => this.zittingId;

  theme: string;
  setTheme(theme: string) {
    this.theme = theme;
  }
  themes = ['green', 'blue', 'orange', 'yellow'];
  setNextTheme() {
    const newThemeIndex = (this.themes.indexOf(this.theme) + 1) % this.themes.length;
    this.theme = this.themes[newThemeIndex];
  }
  getUrl(relativeUrl: string) {
    return `${this.baseUrl}Proxy/Api/${relativeUrl}`;
  }
  getDocUrl(relativeUrl: string) {
    return `${this.baseUrl}Proxy/Api/${relativeUrl}&download=${this.currentDocumentMode.id === DocumentAction.Download}`;
  }

  refreshActiveComponents() {
    this._refreshSubject.next(true);
  }

  refreshCurrentRoute(route: ActivatedRoute, router: Router) {
    router.onSameUrlNavigation = 'reload';
    route.routeConfig.runGuardsAndResolvers = 'always';
    return router.navigateByUrl(router.url).then(_ => {
      router.onSameUrlNavigation = 'ignore';
      route.routeConfig.runGuardsAndResolvers = 'paramsOrQueryParamsChange';
    });
  }

  sendDebugMessage(type: string, message: string) {
    this.channel.postMessage({ type, message });
  }

  getFileExtension(pathname: string) {
    return pathname.indexOf('/')>-1 ?  pathname.slice((pathname.lastIndexOf('.') - 1 >>> 0) + 2) : pathname.slice(pathname.lastIndexOf('.')+1);
  }
  getTitelWithExtension(titel: string, pathname: string) {
    return `${titel} (${this.getFileExtension(pathname)})`;
  }

}
